export default "__VITE_ASSET__W43Krdd7__"